export default __webpack_public_path__ + "static/sustainability_4-cca4c785430b1261bd75028f94c82a29.jpg";